import React from "react";
import LogoContainer from "../header/LogoContainer";
import ProfileContainer from "../header/ProfileContainer";

const ExamHeader = () => {
  return (
    <header className="sticky top-0 flex justify-between items-center bg-primary py-3 rounded-md shadow-md px-2">
      <LogoContainer />
      <div className="sm:block hidden">
        <ProfileContainer />
      </div>
    </header>
  );
};

export default ExamHeader;
